import { cancelHTTPRequests, getElevenLabsConnectionConfigs } from "../utils";
import http from "../webhook/httpconfig";
import { generateHeaders } from "../webhook/webhook";
import store from '../../store';
import { getCookie } from '@/services/cookie'
import { cookieConstant } from "../constants"
import AppError from '../errors/app-errors';
import AppLog from '@/services/errors/app-logs'
import { Room, RoomEvent } from "livekit-client";
import audioUtil from "../audioUtil";

class ConversationHandlerClient {
  constructor() {
    this.liveKitRoom = null;
  }

  async initBackendConversationHandler () {
    // Initializing the conversation handler on backend
    try {
      if(store.getters.voiceTTSProvider === '11labs' && store.getters.elevenLabsWebSocketEnabled && store.getters.enableBackendElevenLabsSocket) {
        const botRefID = store?.state?.botRefId;
        const conversationId = getCookie(cookieConstant.SESSION.CONVERSATION_ID);
        const room = `chat_widget/${botRefID}/${conversationId}`
        new AppLog({
          name: 'initBackendConversationHandler',
          message: `Initializing Live-Kit Conversation Handler from Client Side for room: ${room}`,
          logLevel: 'info',
          service: 'ConversationHandlerClient'
        });

        
        if (!botRefID || !conversationId)
          throw new Error(
            `Missing required details. BotRefID: ${botRefID} ConversationId: ${conversationId}`
          )
        const { data } = await this.getRoomToken()
        new AppLog({
          name: 'initBackendConversationHandler',
          message: `Received token for connecting to Live-Kit Room: ${room} at Client Side`,
          logLevel: 'info',
          service: 'ConversationHandlerClient'
        });

        this.liveKitRoom  = new Room();
        await this.liveKitRoom.connect(
          'wss://netomi-voice-tpnz1u1n.livekit.cloud',
          data.token,
          { autoSubscribe: true }
        )

        new AppLog({
          name: 'initBackendConversationHandler',
          message: `Connected to Live-Kit Room: ${room} at Client Side. Registering textStreamHandler`,
          logLevel: 'info',
          service: 'ConversationHandlerClient'
        });

        this.liveKitRoom.registerTextStreamHandler('', async (reader) => {
          const message = await reader.readAll()
          try {
            new AppLog({
              name: 'initBackendConversationHandler',
              message: `Received audio message on Live-Kit room: ${room} in client side`,
              logLevel: 'info',
              service: 'ConversationHandlerClient'
            });
            audioUtil.handleAudioData({
              audio: message,
              audioIndex: parseInt(reader.info.attributes.audioIndex)
            });
          } catch (err) {
            console.log(err);
            new AppLog({
              name: 'initBackendConversationHandler',
              message: `Error occurred while processing live-kit message for room: ${room} in client side`,
              data: {
                err
              },
              logLevel: 'info',
              service: 'ConversationHandlerClient'
            });
          }
        });

        this.liveKitRoom.on(RoomEvent.Disconnected, (reason) => {
          new AppLog({
            name: 'initBackendConversationHandler',
            message: `Disonnected from Live-Kit Room: ${room} at Client Side. Reason: ${reason}`,
            logLevel: 'info',
            service: 'ConversationHandlerClient'
          });
          this.liveKitRoom = null;
        });

        this.liveKitRoom.on(RoomEvent.ParticipantDisconnected, () => {
          new AppLog({
            name: 'initBackendConversationHandler',
            message: `Server Disonnected from Live-Kit Room: ${room} at Client Side.`,
            logLevel: 'info',
            service: 'ConversationHandlerClient'
          });
          this.liveKitRoom = null;
        });
      }
    } catch (err) {
      new AppError({
        name: 'initBackendConversationHandler',
        message: `Error while initializing Live-Kit Conversation handler: ${err.message} for room:`,
        logLevel: 'error',
        service: 'ConversationHandlerClient'
      })
    }
  }

  async getRoomToken() {
    return await http.request({
      method: 'post',
      url: '/api/live-kit-token',
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      data: {
        voiceSettings: getElevenLabsConnectionConfigs()
      },
      cancelToken: cancelHTTPRequests()
    });
  }
}

export default new ConversationHandlerClient();
